import React from 'react';
import SEOHelmet from '../SEOHelmet';

const GreaterNoidaPage: React.FC = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    //eslint-disable-next-line
  }, []);
  
  return (
    <div className='mb-20 mt-28 max-w-4xl mx-auto px-4'>
      <SEOHelmet />
      <h1 className='text-3xl md:text-5xl font-bold text-center mb-8'>Consultant Neurosurgeon in Greater Noida | Dr. Gangesh Gunjan</h1>
      
      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Neurosurgical Care at Sarvodaya Hospital, Greater Noida West</h2>
        <p className='text-lg text-gray-700 leading-relaxed'>Dr. Gangesh Gunjan serves as Associate Director and Head, Department of Neurosurgery at Sarvodaya Hospital, Greater Noida West. With over 12 years of specialized surgical experience, Dr. Gunjan provides comprehensive clinical evaluation and advanced surgical treatment for cranial, spinal, and peripheral nerve disorders.</p>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Advanced Neurosurgical Procedures</h2>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Micro-endoscopic and tubular discectomy for lumbar disc herniation</li>
          <li>Minimally invasive spinal decompression and stabilization</li>
          <li>Neuronavigation-guided cranial biopsies and brain tumor resections</li>
          <li>Endoscopic transsphenoidal pituitary surgery</li>
          <li>Microsurgical management of vascular malformations and aneurysms</li>
          <li>Peripheral nerve decompression for carpal tunnel and entrapment syndromes</li>
        </ul>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Clinical Services & Conditions Treated</h2>
        <p className='text-lg text-gray-700 mb-3'>Providing detailed outpatient and inpatient evaluation for conditions including:</p>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Cranial tumors (gliomas, meningiomas, acoustic neuromas, pituitary lesions)</li>
          <li>Spine disorders (herniated discs, cervical myelopathy, degenerative lumbar stenosis)</li>
          <li>Spinal deformities, scoliosis, and spondylolisthesis</li>
          <li>Chiari malformations and syringomyelia</li>
          <li>Trigeminal neuralgia and cranial neuropathy</li>
          <li>Peripheral nerve entrapment and trauma</li>
        </ul>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Neuro-Oncology Program</h2>
        <p className='text-lg text-gray-700 leading-relaxed mb-3'>Our neuro-oncology service coordinates multidisciplinary tumor boards combining surgical resection with targeted oncological therapies:</p>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Awake craniotomy for preservation of speech and motor cortex</li>
          <li>Fluorescence-guided tumor resection for visual identification of tumor boundaries</li>
          <li>Intraoperative neurophysiological monitoring (IONM) to safeguard neural pathways</li>
          <li>Coordinated post-operative stereotactic radiotherapy planning</li>
        </ul>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Neurotrauma & Emergency Surgical Care</h2>
        <p className='text-lg text-gray-700 leading-relaxed mb-3'>Providing clinical evaluation and emergency surgical management for acute neurotrauma:</p>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Traumatic brain injuries, acute subdural and epidural hematomas</li>
          <li>Spinal cord trauma, vertebral fractures, and spinal instability</li>
          <li>Emergency decompressive craniectomies</li>
          <li>Coordinated critical care monitoring in the dedicated Neuro-ICU</li>
        </ul>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Patient-Centric Approach</h2>
        <p className='text-lg text-gray-700 leading-relaxed mb-3'>Care is centered around patient understanding and transparent clinical communication:</p>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Comprehensive preoperative counseling on surgical risks, benefits, and alternatives</li>
          <li>Personalized postoperative rehabilitation and physical therapy coordination</li>
          <li>Structured follow-up reviews to track long-term recovery</li>
        </ul>
      </section>

      <section className='mb-8 bg-blue-50 p-6 rounded-2xl border border-blue-100'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-3 text-blue-900'>Schedule an Appointment in Greater Noida West</h2>
        <p className='text-lg text-gray-700 leading-relaxed mb-4'>
          To consult with Dr. Gangesh Gunjan, please call{' '}
          <a href="tel:+917727834367" className='text-blue-600 font-semibold hover:underline'>+91-7727834367</a>{' '}
          or visit Room no. 1011, Sarvodaya Hospital, Sector 16C, Gaur City 2, Greater Noida West, Uttar Pradesh 201009.
        </p>
      </section>
    </div>
  );
};

export default GreaterNoidaPage;